import { h, withDirectives, Transition, vShow } from 'vue';
import { a as registerComponent } from './plugins-C7548x21.js';

var script = {
    name: 'BCollapse',
    props: {
        modelValue: {
            type: Boolean,
            default: true
        },
        animation: {
            type: String,
            default: 'fade'
        },
        ariaId: {
            type: String,
            default: ''
        },
        position: {
            type: String,
            default: 'is-top',
            validator(value) {
                return [
                    'is-top',
                    'is-bottom'
                ].indexOf(value) > -1
            }
        }
    },
    emits: ['close', 'open', 'update:modelValue'],
    data() {
        return {
            isOpen: this.modelValue
        }
    },
    watch: {
        modelValue(value) {
            this.isOpen = value;
        }
    },
    methods: {
        /**
        * Toggle and emit events
        */
        toggle() {
            this.isOpen = !this.isOpen;
            this.$emit('update:modelValue', this.isOpen);
            this.$emit(this.isOpen ? 'open' : 'close');
        }
    },
    render() {
        const trigger = h(
            'div',
            {
                class: 'collapse-trigger',
                onClick: this.toggle
            },
            this.$slots.trigger
                ? this.$slots.trigger({ open: this.isOpen })
                : undefined
        );
        const content = withDirectives(
            h(
                Transition,
                { name: this.animation },
                () => [
                    h(
                        'div',
                        {
                            class: 'collapse-content',
                            id: this.ariaId
                        },
                        this.$slots
                    )
                ]
            ),
            [[vShow, this.isOpen]]
        );
        return h(
            'div',
            { class: 'collapse' },
            this.position === 'is-top' ? [trigger, content] : [content, trigger]
        )
    }
};

script.__file = "src/components/collapse/Collapse.vue";

var Plugin = {
  install: function install(Vue) {
    registerComponent(Vue, script);
  }
};

export { script as BCollapse, Plugin as default };
